/**
 * Sidebar badge counts hook (D-04).
 *
 * Derives sidebar badge failure counts from dashboard stats.
 * Shows non-zero counts for: failed commands, failed jobs, unattributed sales.
 */
import { useDashboardStats } from './use-dashboard-stats';

export interface SidebarBadgeCounts {
  commands?: number;
  events?: number;
  sales?: number;
}

/**
 * Derives sidebar badge failure counts from dashboard stats (D-04).
 * Shows non-zero counts for: failed commands, failed jobs, unattributed sales.
 */
export function useSidebarBadgeCounts(): SidebarBadgeCounts {
  const { data: stats } = useDashboardStats();
  if (!stats) return {};

  return {
    commands: stats.commands24h.failed > 0 ? stats.commands24h.failed : undefined,
    events: stats.jobs24h.failed > 0 ? stats.jobs24h.failed : undefined,
    sales: stats.sales24h.unattributed > 0 ? stats.sales24h.unattributed : undefined,
  };
}
